import React from 'react';
import PropTypes from 'prop-types';
import {Box} from '@material-ui/core';

const SlidesContent = ({children}) => <Box>{children}</Box>;

SlidesContent.propTypes = {
  children: PropTypes.node.isRequired,
};

export default SlidesContent;
